var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedxlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 166,
    viewBox: "0 0 553 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.05 83.24C94.05 79.3 94.32 75.42 94.85 71.62C91.05 72.15 87.17 72.42 83.23 72.42C79.29 72.42 75.41 72.15 71.61 71.62C72.14 75.42 72.41 79.3 72.41 83.24C72.41 87.18 72.14 91.06 71.61 94.86C75.41 94.33 79.29 94.06 83.23 94.06C87.17 94.06 91.05 94.33 94.85 94.86C94.32 91.06 94.05 87.18 94.05 83.24Z",
    fill: "#C3FF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85 71.62C131.97 66.49 161.34 37.11 166.47 -7.62939e-06C129.36 5.12999 99.98 34.5 94.85 71.62Z",
    fill: "#C3FF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0100021 -0.0100098C5.12 37.11 34.5 66.48 71.61 71.61C66.47 34.5 37.1 5.12999 -0.0100021 -0.0100098Z",
    fill: "#C3FF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0100021 166.48C37.11 161.35 66.48 131.97 71.61 94.86C34.49 99.99 5.12 129.36 -0.0100021 166.48Z",
    fill: "#C3FF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85 94.86C99.98 131.98 129.36 161.35 166.47 166.48C161.34 129.36 131.97 99.99 94.85 94.86Z",
    fill: "#C3FF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78 100.03H202.35C203.55 110.84 213.76 117.69 228.53 117.69C241.38 117.69 248.11 112.41 248.11 103.64C248.11 95.11 240.66 91.87 232.62 89.35L218.09 84.79C211.36 82.63 194.43 79.02 194.43 62.57C194.43 49 205.6 40.11 223.02 40.11C242.24 40.11 254.13 49.84 255.45 67.73H245C244.16 55.84 235.87 49.23 222.54 49.23C211.97 49.23 204.52 54.03 204.52 62.08C204.52 71.33 214.13 73.25 221.34 75.53L234.91 79.73C245.6 83.09 258.45 87.3 258.45 103.15C258.45 117.92 247.16 126.81 228.54 126.81C207.39 126.82 192.86 115.89 191.78 100.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4 93.91C268.4 72.17 282.45 60.4 298.55 60.4C316.09 60.4 327.38 72.17 327.74 92.59V95.35H278.38C278.98 108.92 286.91 118.17 299.76 118.17C308.65 118.17 315.13 113.73 317.78 105.44H327.51C324.63 118.53 314.3 126.82 299.76 126.82C280.89 126.82 268.4 113 268.4 93.91ZM317.28 87.06C315.48 75.89 308.75 69.04 298.54 69.04C288.45 69.04 281 75.65 278.96 87.06H317.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.58 93.91C337.58 72.17 351.63 60.4 367.73 60.4C385.27 60.4 396.56 72.17 396.92 92.59V95.35H347.56C348.16 108.92 356.09 118.17 368.94 118.17C377.83 118.17 384.31 113.73 386.96 105.44H396.69C393.81 118.53 383.48 126.82 368.94 126.82C350.07 126.82 337.58 113 337.58 93.91ZM386.46 87.06C384.66 75.89 377.93 69.04 367.72 69.04C357.63 69.04 350.18 75.65 348.14 87.06H386.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.75 93.31C406.75 73.85 418.52 60.4 435.58 60.4C445.19 60.4 453.24 64.6 457.8 71.33V41.42H467.77V125.5H459.84L458.76 113.25C454.56 121.54 446.15 126.82 435.7 126.82C418.64 126.82 406.75 113.12 406.75 93.31ZM457.8 93.07C457.8 78.78 449.63 68.93 437.86 68.93C425.61 68.93 417.08 78.9 417.08 93.31C417.08 107.96 425.37 118.17 437.26 118.17C449.39 118.17 457.8 107.84 457.8 93.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.8 125.56L508.76 83.23L476.79 41.33H489.04L515 75.31L540.52 41.34H552.77L521.36 83L552.78 125.56H540.53L515.12 90.92L489.06 125.58L476.8 125.56Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 553,
    height: 166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedxlogo);
export default __webpack_public_path__ + "static/media/seedxlogo.19c9cd769d43e393b132b69e2bb41a57.svg";
export { ForwardRef as ReactComponent };